module.exports = __webpack_public_path__ + "fb8f5a39e55a5aa585f3431fe4ce47df.gif";